define('Components/SeparatorWidget/js/models/SeparatorWidgetInstanceModel',['jquery', 'WidgetInstanceModel', 'app'], function ($, WidgetInstanceModel, app) {
    return WidgetInstanceModel.extend({
        getImage: function (suffix, format) {

            // default picture settings
            suffix = suffix ? suffix : 'noscale';
            format = format ? format : 'JPG';

            var model = this,
                id_picture = model.p('background_image'), id_picture_mobile,
                baseline = model.get('baseline'),
                url;
            url = app.getPictureUrl(id_picture, 'Widget', suffix, format, baseline);
console.log(url, id_picture, baseline);

            return url || false;
        }
    })
});

